import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { imgUrl, priceLabel } from "@/lib/api";
import { Stars } from "./ReviewForm";

export default function ProductCard({ p, i = 0 }) {
  return (
    <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: (i % 4) * 0.07 }}>
      <Link to={`/p/${p.slug}`} data-testid={`product-card-${p.slug}`} className="group block">
        <div className="img-zoom aspect-[4/5] overflow-hidden rounded-3xl bg-[var(--lilac)]">
          <img src={imgUrl(p.images?.[0])} alt={p.alt || p.name} loading="lazy" className="h-full w-full object-cover" />
        </div>
        <div className="mt-4 flex items-start justify-between gap-3 px-1">
          <h3 className="text-base font-semibold leading-snug transition-colors group-hover:text-[var(--violet)]">{p.name}</h3>
          {p.price_type === "fixed" && <span className="shrink-0 rounded-full bg-[var(--lilac)] px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wider text-[var(--violet)]">Online</span>}
        </div>
        <p className="mt-1 px-1 text-sm font-bold text-[var(--violet)]">{priceLabel(p)}</p>
        {p.rating && <p className="mt-1 flex items-center gap-1 px-1 text-xs text-[var(--muted-ink)]" data-testid={`product-card-rating-${p.slug}`}><Stars value={p.rating.avg} size="h-3 w-3" />({p.rating.count})</p>}
      </Link>
    </motion.div>
  );
}
